import {GridPhoto} from 'platform/components';

import {pipe, propEq, prop, defaultTo, filter, map, sortBy, chain, uniqBy} from 'ramda';

import {
  AuditDataAssetsBody,
  AuditDataAssetsFilesBody,
  AuditDataVideoAssetsBody,
  LoadAuditDataCategories,
} from '@dms/api/core';
import {ServiceAlbumPhotoResponseBody, VehicleAlbumPhotoV2ResponseBody} from '@dms/api/sales';
import {VehiclePhotoResponseBody} from '@dms/api/shared';

type ServiceCaseAlbumPhoto =
  | ServiceAlbumPhotoResponseBody
  | VehicleAlbumPhotoV2ResponseBody
  | VehiclePhotoResponseBody;

export const getGridServiceAlbumPhotos = pipe<
  [ServiceCaseAlbumPhoto[] | undefined],
  ServiceCaseAlbumPhoto[],
  ServiceCaseAlbumPhoto[],
  GridPhoto[]
>(
  defaultTo([]),
  sortBy(prop('weight')),
  map((photo) => ({
    url: photo.url,
    originalUrl: photo.url.replace('resize', 'get'),
    resizeUrl: photo.url,
    makeUrl: (url, width) => `${url}&width=${width}`,
    id: photo.id,
  }))
);

export const getGridPhotos = (albumId?: string) =>
  pipe<
    [VehiclePhotoResponseBody[] | undefined],
    VehiclePhotoResponseBody[],
    VehiclePhotoResponseBody[],
    VehiclePhotoResponseBody[],
    GridPhoto[]
  >(
    defaultTo([]),
    filter(propEq(albumId, 'albumId')),
    sortBy(prop('weight')),
    map((photo) => ({
      url: photo.url,
      originalUrl: photo.url.replace('resize', 'get'),
      resizeUrl: photo.url,
      makeUrl: (url, width) => `${url}&width=${width}`,
      id: photo.id,
    }))
  );

export const getGridPhotosFromAudit = (auditCategories?: LoadAuditDataCategories[]) =>
  pipe(
    defaultTo<LoadAuditDataCategories[]>([]),
    chain((category: LoadAuditDataCategories) => category.assets),
    chain((audit: AuditDataAssetsBody) => audit.files),
    uniqBy(prop('uploadedAssetId')),
    map<AuditDataAssetsFilesBody, GridPhoto>((file) => ({
      url: file.url,
      originalUrl: file.url,
      resizeUrl: file.resizeUrl,
      id: file.uploadedAssetId,
      makeUrl: (url, width) => `${url}&width=${width}`,
    }))
  )(auditCategories);

export const getGridVideosFromAudit = (auditCategories?: LoadAuditDataCategories[]) =>
  pipe(
    defaultTo<LoadAuditDataCategories[]>([]),
    chain((category: LoadAuditDataCategories) => category.videoAssets),
    chain((audit: AuditDataVideoAssetsBody) => audit.videos),
    uniqBy(prop('videoId'))
  )(auditCategories);
